// Module
var code = "<template> <require from=\"app/cd/components/summary/claim/claim-summary\"></require> <claim-summary claim.bind=\"claim\"></claim-summary> </template> ";
// Exports
module.exports = code;